module.exports = __webpack_public_path__ + "static/media/reception.457fb8ee.png";